// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../endOfYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var endOfYear = convertToFP(fn, 1);
export default endOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/endOfYear/index.js
// module id = 869
// module chunks = 0